import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../actions/userActions';
import './Header.css';

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector(state => state.authState);

  const logoutHandler = () => {
    dispatch(logout);
    navigate('/glogin');
  };

  return (
    <nav className="navbar row align-items-center m-0 px-2 px-md-4">
      {/* Left: Logo brand linking to dashboard */}
      <div className="col-7 col-md-4 d-flex align-items-center">
        <Link to="/dashboard" className="d-flex align-items-center gap-2 text-decoration-none">
          <img 
            src="/images/logo-light.jpg" 
            alt="Green Naturopathy" 
            style={{ height: '34px', width: 'auto', borderRadius: '6px', objectFit: 'contain', flexShrink: 0 }} 
          />
          <span className="navbar-brand-title" style={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>
            Green Naturopathy
          </span>
        </Link>
      </div>

      {/* Center: page label (desktop only) */}
      <div className="col-md-4 d-none d-md-flex justify-content-center">
        <span style={{ color: '#64748b', fontSize: '0.78rem', fontWeight: 500 }}>
          Pain Clinic & Holistic Healthcare
        </span>
      </div>

      {/* Right: user info + logout */}
      <div className="col-5 col-md-4 d-flex justify-content-end align-items-center gap-2">
        {isAuthenticated && (
          <>
            <span style={{ color: '#94a3b8', fontSize: '0.8rem', fontWeight: 500 }}
              className="d-none d-md-inline">
              {user?.name}
            </span>
            <button onClick={logoutHandler} className="btn-logout">
              <i className="fa fa-sign-out-alt me-1"></i> Logout
            </button>
          </>
        )}
      </div>
    </nav>
  );
}
